import React, { useEffect, useState } from "react";
import SvgIcon from "./SvgIcon";
import { setAppliedMode } from "../utils/theme-helpers";
import PropTypes from "prop-types";
import submit from "submit-form";

const ThemeToggler = ({ expanded }, context) => {
  const { locals } = context;
  const [theme, setTheme] = useState(locals.activeUser?.webAppTheme || "");
  const toggleTheme = () => {
    const themeToSet = theme === "dark" ? "light" : "dark";
    setTheme(themeToSet);
    setAppliedMode(themeToSet);

    const isFromChat = locals.pathname.includes("/coaching-portal/chat");

    submit("/actions/theme", {
      method: "POST",
      body: {
        webAppTheme: themeToSet,
        isFromChat,
      },
    });
  };

  return (
    <button className={theme} onClick={toggleTheme}>
      <>
        <div aria-current={theme === "light" ? true : undefined}>
          <SvgIcon
            src={`/img/new-icons/light-theme-${
              theme === "light" ? "enabled" : "disabled"
            }.svg`}
          />
          <span>Light</span>
        </div>
        <SvgIcon
          aria-current
          src={`/img/new-icons/${
            theme === "dark" ? "dark" : "light"
          }-theme-enabled.svg`}
          noFilterOnLight={true}
        />
        <div aria-current={theme === "dark" ? true : undefined}>
          <SvgIcon
            src={`/img/new-icons/dark-theme-${
              theme === "dark" ? "enabled" : "disabled"
            }.svg`}
          />
          <span>Dark</span>
        </div>
      </>

      {/* {expanded ? (
        <>
          <div aria-current={theme === "light" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/light-theme-${
                theme === "light" ? "enabled" : "disabled"
              }.svg`}
            />
            <span>Light</span>
          </div>
          <div aria-current={theme === "dark" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/dark-theme-${
                theme === "dark" ? "enabled" : "disabled"
              }.svg`}
            />
            <span>Dark</span>
          </div>
        </>
      ) : (
        <SvgIcon
          aria-current
          src={`/img/new-icons/${
            theme === "dark" ? "dark" : "light"
          }-theme-enabled.svg`}
          noFilterOnLight={theme === "light"}
        />
      )} */}
    </button>
  );
};
ThemeToggler.contextTypes = { locals: PropTypes.object };

export default ThemeToggler;
